/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import CardBody from '../CardBody'
import { createId } from '@/utils/general'
import Styles from './styles.module.sass'

const ItemCardDetails = ({
  className = '',
  creatorsLabel = 'By',
  creators,
  details = [],
  title
}) => {
  const detailsRows = details.map(detail => {
    return (
      <li className="mb-1 last:mb-0" key={createId()}>
        <p className="text-[13px] text-[#6a6a72]">
          { detail.label &&
            <span className="font-bold mr-1">
              { detail.label}:
            </span>
          }
          { detail.value &&
            <span>
              { detail.value}
            </span>
          }
        </p>
      </li>
    )
  })
  return (
    <CardBody
      className={`${className} min-w-0`}
    >
      <h3 className={`${Styles.title} truncate`}>
        { title }
      </h3>
      { creators &&
        <p className={`${Styles.creators} truncate`}>
          <span className="mr-3">
            { creatorsLabel }:
          </span>
          <span>
            { creators }
          </span>
        </p>
      }
      { detailsRows &&
        <ul>
          { detailsRows }
        </ul>
      }
    </CardBody>
  )
}

export default ItemCardDetails
